<template>
    <hts-modal
        v-model="visible"
        :title="cTitle"
        @close="resetFields">
        <template #custom>
            <div
                v-for="(item, index) in containerNumbers"
                :key="index"
                class="mb-2 flex gap-2 items-center align-middle">
                <hts-form-input
                    v-model="item.containerNumber"
                    required
                    class="w-full"
                    label="Số container" />

                <hi-x-circle-icon
                    class="h-6 w-6 ml-2 mt-4 text-error-500 cursor-pointer"
                    @click="($event: any) => deleteContainerNumber($event, index)" />
            </div>

            <hts-form-button
                color="info"
                :loading="false"
                size="small"
                @click="addContainerNumber">
                Thêm số container
            </hts-form-button>

            <div class="flex mt-5 justify-end">
                <hts-form-button
                    class="pl-2"
                    color="error"
                    @click="close">
                    {{ $t('labels.cancel') }}
                </hts-form-button>

                <hts-form-button
                    color="primary"
                    type="submit"
                    :loading="false"
                    @click="submit">
                    Lưu
                </hts-form-button>
            </div>
        </template>
    </hts-modal>
</template>

<script setup lang="ts">
import { $api, $url } from '#imports'
const emits = defineEmits(['refreshTables'])
const { $formatters } = useNuxtApp()

const visible = ref(false)

const journeyId = ref('')
const type = ref('create')

const containerNumbers = ref<{ [key: string]: any }[]>([
  {
    _id: $formatters.generateId(),
    containerNumber: ''
  }
])

const addContainerNumber = () => {
  containerNumbers.value.push({
    _id: $formatters.generateId(),
    containerNumber: ''
  })
}

const deleteContainerNumber = (e: Event, index: number) => {
  e.preventDefault()
  e.stopPropagation()

  if (index < 0 || index >= containerNumbers.value.length) {
    return
  }
  containerNumbers.value.splice(index, 1)
  if (!containerNumbers.value || !Array.isArray(containerNumbers.value) || !containerNumbers.value.length) {
    containerNumbers.value = [
      {
        _id: $formatters.generateId(),
        containerNumber: ''
      }
    ]
  }
}

const cTitle = computed(() => {
  if (type.value === 'edit') {
    return 'Chỉnh sửa số container'
  }

  return 'Thêm số container'
})

const open = (id: string, containerNumbersValue?: { [key: string]: any }[]) => {
  if (containerNumbersValue?.length) {
    type.value = 'edit'
  } else {
    type.value = 'create'
  }
  journeyId.value = id
  visible.value = true
  containerNumbers.value = containerNumbersValue || [
    {
      _id: $formatters.generateId(),
      containerNumber: ''
    }
  ]
}

const close = () => {
  resetFields()
  visible.value = false
}

const resetFields = () => {
  journeyId.value = ''
  containerNumbers.value = [
    {
      _id: $formatters.generateId(),
      containerNumber: ''
    }
  ]
}

const submit = async () => {
  const api = $url.journey.distribution.updateContainerNo

  const data: any = await $api(api, {
    uriParams: { ID: journeyId.value },
    body: {
      containerNumbers: containerNumbers.value
    }
  })

  const resData = data?.data?.value
  if (resData?.success) {
    emits('refreshTables')
    if (type.value === 'edit') {
      process.client && $toast().success($t('labels.updateSuccess'))
    } else {
      process.client && $toast().success($t('labels.addSuccess'))
    }
    close()
  }
}

defineExpose({ open })
</script>
